"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastReducer = void 0;

var actions_1 = require("./actions");

var INITIAL_STATE = [];

function toastReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions_1.RENDER_TOAST:
      {
        var id = action.payload.id;
        return [].concat(_toConsumableArray(state), [id]);
      }

    case actions_1.HIDE_TOAST:
      {
        var _id = action.payload.id;
        return state.filter(function (stateId) {
          return stateId !== _id;
        });
      }

    default:
      return state;
  }
}

exports.toastReducer = toastReducer;